import { render, staticRenderFns } from "./SidWidthAndHeight.vue?vue&type=template&id=533d52dc"
import script from "./SidWidthAndHeight.vue?vue&type=script&lang=js"
export * from "./SidWidthAndHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports